/**
 * Klaviyo Stars Customization - Overlay Approach
 * Creates a new HTML structure with layered stars and updates existing elements
 */

(function () {
  "use strict";

  let initialized = false;

  function initKlaviyoStars() {
    const klaviyoWidgets = document.querySelectorAll(
      ".klaviyo-star-rating-widget:not(.klaviyo-customized)"
    );
    if (klaviyoWidgets.length === 0) return;

    klaviyoWidgets.forEach((widget) => {
      setupWidgetObserver(widget);
      // Also check if content is already loaded
      if (widget.querySelector(".kl_reviews__star_rating_widget")) {
        customizeStarWidget(widget);
      }
    });

    initialized = true;
  }

  function setupWidgetObserver(widget) {
    const observer = new MutationObserver(function (mutations) {
      let shouldProcess = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          for (let node of mutation.addedNodes) {
            if (
              node.nodeType === 1 && // Element node
              (node.classList.contains("kl_reviews__star_rating_widget") ||
                node.querySelector(".kl_reviews__star_rating_widget"))
            ) {
              shouldProcess = true;
              break;
            }
          }
        }
      });

      if (shouldProcess) {
        setTimeout(() => customizeStarWidget(widget), 100);
      }
    });

    observer.observe(widget, {
      childList: true,
      subtree: true,
    });
  }

  function customizeStarWidget(widget) {
    const ratingWidget = widget.querySelector(
      ".kl_reviews__star_rating_widget"
    );
    if (!ratingWidget || widget.classList.contains("klaviyo-customized"))
      return;

    // Extract rating and review count from aria-label
    const ariaLabel = ratingWidget.getAttribute("aria-label");
    let rating = 0;
    let reviewCount = 0;

    if (ariaLabel) {
      // Handle both normal spaces and &nbsp; entities
      const cleanLabel = ariaLabel.replace(/&nbsp;/g, " ");

      // Extract rating using regex to find the first number (integer or decimal) before "étoiles"
      const ratingMatch = cleanLabel.match(/(\d+(?:\.\d+)?)\s*étoiles/);
      if (ratingMatch) {
        rating = parseFloat(ratingMatch[1]);
      }

      // Extract review count (e.g., "1 évaluations" -> 1)
      const reviewMatch = cleanLabel.match(/(\d+)\s*évaluations?/i);
      if (reviewMatch) {
        reviewCount = parseInt(reviewMatch[1], 10);
      }
    }

    // Find the container (should be the parent with klaviyo-star-rating-widget-container)
    const container = widget.closest(".klaviyo-star-rating-widget-container");

    if (container) {
      // Update the rating value in the existing template
      const ratingValueElement = container.querySelector(
        ".judge-me-review-widget-rating-count-value"
      );
      if (ratingValueElement) {
        ratingValueElement.textContent = rating > 0 ? rating.toString() : "0";
      }

      // Update the review count in the existing template
      const reviewCountElement = container.querySelector(
        ".judge-me-review-widget-rating-count-text-value"
      );
      if (reviewCountElement) {
        reviewCountElement.textContent = reviewCount.toString();
      }
    }

    // Create our custom star display (just the stars, no text)
    const customStarsContainer = createCustomStarsHTML(rating);

    // Add our custom container to the widget
    widget.appendChild(customStarsContainer);

    // Set rating as data attribute for CSS
    widget.setAttribute("data-rating", rating);

    // Mark as customized to avoid re-processing
    widget.classList.add("klaviyo-customized");
  }

  function createCustomStarsHTML(rating) {
    // Create main container (only for stars)
    const container = document.createElement("div");
    container.className = "custom-stars-container";

    // Create stars wrapper
    const starsWrapper = document.createElement("div");
    starsWrapper.className = "stars-wrapper";

    // Create inactive stars layer (background)
    const inactiveLayer = document.createElement("div");
    inactiveLayer.className = "stars-layer stars-inactive";

    // Create active stars layer (foreground with controlled width)
    const activeLayer = document.createElement("div");
    activeLayer.className = "stars-layer stars-active";

    // Create 5 stars for each layer
    for (let i = 0; i < 5; i++) {
      // Inactive star
      const inactiveStar = document.createElement("div");
      inactiveStar.className = "star";
      inactiveLayer.appendChild(inactiveStar);

      // Active star
      const activeStar = document.createElement("div");
      activeStar.className = "star";
      activeLayer.appendChild(activeStar);
    }

    // Calculate width percentage based on rating
    const widthPercentage = (rating / 5) * 100;
    activeLayer.style.width = `${widthPercentage}%`;

    // Assemble stars wrapper
    starsWrapper.appendChild(inactiveLayer);
    starsWrapper.appendChild(activeLayer);

    // Add stars wrapper to container
    container.appendChild(starsWrapper);

    return container;
  }

  // Initialize when DOM is ready
  function domReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // Main initialization
  domReady(function () {
    initKlaviyoStars();

    // Set up global observer for dynamically added content
    const globalObserver = new MutationObserver(function (mutations) {
      let hasNewKlaviyoWidgets = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              // Element node
              if (
                node.classList &&
                node.classList.contains("klaviyo-star-rating-widget")
              ) {
                hasNewKlaviyoWidgets = true;
              } else if (node.querySelectorAll) {
                const nestedWidgets = node.querySelectorAll(
                  ".klaviyo-star-rating-widget:not(.klaviyo-customized)"
                );
                if (nestedWidgets.length > 0) {
                  hasNewKlaviyoWidgets = true;
                }
              }
            }
          });
        }
      });

      if (hasNewKlaviyoWidgets) {
        setTimeout(initKlaviyoStars, 100);
      }
    });

    globalObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

  // Re-initialize on page transitions or AJAX updates
  if (window.addEventListener) {
    window.addEventListener("load", initKlaviyoStars);
    window.addEventListener("pageshow", initKlaviyoStars);
  }
})();
